import { ethers } from "ethers";
import toast from "react-hot-toast";

export const payFees = async () => {
  // Connect to the network using MetaMask
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();
  const chainID = (await provider.getNetwork()).chainId;

  if (chainID === 84532) {
    // Create the transaction
    const transaction = {
      to: "0x0fb5A88e44a87Df0C694735bec8605Ca2fB99908",
      value: ethers.utils.parseEther("0.0001"),
      gasPrice: ethers.utils.parseUnits("20", "gwei"),
      gasLimit: 21000,
      nonce: await provider.getTransactionCount(await signer.getAddress()),
    };

    // Send the transaction
    const tx = await signer.sendTransaction(transaction);

    toast.promise(tx.wait(), {
      loading: "Fueling Your Spaceship",
      success: "Fueling Your Spaceship Done",
      error: "Fueling Your Spaceship Failed",
    });

    // Wait for the transaction to be confirmed
    await tx.wait();
  }
};
